import { useSelector } from 'modules/react-redux';

import { getQBooksAccountLineItems } from '../../../../../selectors/qbooks';
import { useRequest } from './useRequest';

export const useAccountLineItems = () => {
    const request = useRequest();

    return useSelector((state) => getQBooksAccountLineItems(state, request));
};
